import { IconSVG } from '../types';

export const Fullscreen = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      style={style}
    >
      <path
        fill="currentColor"
        d="M5 19h2c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.712A.967.967 0 017 21H4a.967.967 0 01-.712-.288A.968.968 0 013 20v-3c0-.283.096-.52.288-.712A.967.967 0 014 16c.283 0 .52.096.713.288.191.191.287.429.287.712v2zm14 0v-2c0-.283.096-.52.288-.712A.968.968 0 0120 16c.283 0 .52.096.712.288.192.191.288.429.288.712v3c0 .283-.096.52-.288.712A.968.968 0 0120 21h-3a.968.968 0 01-.712-.288A.968.968 0 0116 20c0-.283.096-.52.288-.712A.968.968 0 0117 19h2zM5 5v2c0 .283-.096.52-.287.713A.968.968 0 014 8a.968.968 0 01-.712-.287A.968.968 0 013 7V4c0-.283.096-.52.288-.712A.968.968 0 014 3h3c.283 0 .52.096.713.288.191.191.287.429.287.712s-.096.52-.287.713A.968.968 0 017 5H5zm14 0h-2a.968.968 0 01-.712-.287A.967.967 0 0116 4c0-.283.096-.52.288-.712A.968.968 0 0117 3h3c.283 0 .52.096.712.288.192.191.288.429.288.712v3c0 .283-.096.52-.288.713A.968.968 0 0120 8a.968.968 0 01-.712-.287A.967.967 0 0119 7V5z"
      />
    </svg>
  );
};
